import firebase from "store/firebase";
import "firebase/firestore";

import { AnyAction, Dispatch } from "redux";
import { RootState, StoreError } from "store/reducer";
import { loadIdResource } from "store/util/id-resource";
import { eventFromDoc } from "../events/utils";
import { beerFromDoc, beerFromEventBeerName, beerIdFromName } from "./utils";
import { Beer, beersActions } from "./reducer";

export default function load(eventId: string) {
  return async (
    dispatch: Dispatch<AnyAction>,
    getState: () => RootState
  ) => {
    // No early-return on already-loaded; staleness is handled at commit-time
    // by the request-token guard inside the id-resource reducer. The commit
    // contains Firestore data only (names + tasting notes) — bottle image
    // URLs resolve lazily per card via useBeerImageUrl as cards scroll into
    // view, so Storage traffic never delays the list.
    await loadIdResource<Beer[], RootState>(
      eventId,
      async () => {
        const { auth } = getState();
        if (!auth.user?.email) {
          throw new StoreError("No current user.");
        }
        const doc = await firebase
          .firestore()
          .collection("events")
          .doc(eventId)
          .get();
        const item = eventFromDoc(doc);
        const eventBeers = item.beers ?? [];
        const gets = eventBeers.map(async (name) => {
          const id = beerIdFromName(name);
          if (!id) return beerFromEventBeerName(name);
          const beerDoc = await firebase
            .firestore()
            .collection("beers")
            .doc(id)
            .get();
          return beerDoc.exists
            ? beerFromDoc(beerDoc)
            : beerFromEventBeerName(name);
        });
        return Promise.all(gets);
      },
      {
        actions: beersActions,
        selectSlice: (root) => root.beers,
      }
    )(dispatch, getState);
  };
}
